module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":"/home/denni/Programming/TypeScript/2048/.gatsby","babel":true},
    }]
